import { createSlice } from "@reduxjs/toolkit";

import type { MasterDataType } from "./masterTypes";

import {
  checkUniqueBranchNameAction,
  checkUniqueClientGroupNameAction,
  checkUniqueCode,
  checkUniquePdfTemplateNameAction,
  createMasterClientGroupAction,
  createMasterDataActivityCodeAction,
  createMasterDataBranchAction,
  createMasterDataClientCategoryAction,
  createMasterDataCurrencyAction,
  createMasterDataJobTitleAction,
  createMasterDataQualificationModuleAction,
  createMasterDataScopeOfWorkAction,
  createMasterDataSkillsModuleAction,
  createMasterDataUsersDepartmentAction,
  createMasterEmailersAction,
  createMasterHolidayCalenderAction,
  createMasterPdfTemplateAction,
  createMasterTcsModuleAction,
  createMasterTdsModuleAction,
  deleteHolidayCalenderAction,
  deleteMasterDataJobTitleAction,
  deleteMasterDataQualificationAction,
  deleteMasterDataScopeOfWorkAction,
  deleteMasterDataSkillsAction,
  deleteMasterDataUsersDepartmentAction,
  deleteMasterPdfTemplateAction,
  deleteMasterTcsModuleAction,
  deleteMasterTdsModuleAction,
  getAllCityAction,
  getAllCityPermanentAddressAction,
  getAllCountryAction,
  getAllMasterDataActivityCodeAction,
  getAllMasterDataBranchAction,
  getAllMasterDataCurrencyAction,
  getAllStateAction,
  getAllStatePermanentAddressAction,
  getCurrencyExchangeAction,
  getMasterDataActivityCodeAction,
  getMasterDataBranchAction,
  getMasterDataClientCategoryAction,
  getMasterDataClientGroupAction,
  getMasterDataCurrencyAction,
  getMasterDataEmailersAction,
  getMasterDataHolidayCalenderAction,
  getMasterDataJobTitleAction,
  getMasterDataQualificationModuleAction,
  getMasterDataScopeOfWorkAction,
  getMasterDataSkillsModuleAction,
  getMasterDataUsersDepartmentAction,
  getMasterPdfTemplateListAction,
  getMasterTcsModuleAction,
  getMasterTcsModuleSingleAction,
  getMasterTdsModuleAction,
  getMasterTdsModuleSingleAction,
  updateMasterDataActivityCodeAction,
  updateMasterDataBranchAction,
  updateMasterDataClientCategoryAction,
  updateMasterDataClientGroupAction,
  updateMasterDataCurrencyAction,
  updateMasterDataEmailersAction,
  updateMasterDataHolidayCalenderAction,
  updateMasterDataJobTitleAction,
  updateMasterDataQualificationModuleAction,
  updateMasterDataScopeOfWorkAction,
  updateMasterDataSkillsModuleAction,
  updateMasterDataUsersDepartmentAction,
  updateMasterPdfTemplateAction,
  updateMasterTcsModuleAction,
  updateMasterTdsModuleAction,
  initialState,
  masterReducer,
  getTicketSubCategoryListAction,
  addTicketSubCategoryAction,
  updateTicketSubCategoryAction,
  updateTicketSubCategoryStatusAction,
  getTicketCategoryListAction,
  addTicketCategoryAction,
  updateTicketCategoryAction,
  updateTicketCategoryStatusAction,
  getTicketCategoryDetailsAction,
  listKraAction,
  addKraAction,
  updateKraAction,
  updateKraStatusAction,
  deleteKraAction,
  addKpiAction,
  getKpiListAction,
  getSingleKpiDetailsAction,
  updateKpiDetailsAction,
  getNatureOfTransactionListAction,
  getRelationshipTypeListAction,
  getApplicableActListAction,
} from "@/redux/masterData/";

export const masterDataSlice = createSlice({
  name: "masterData",
  initialState,
  reducers: masterReducer,

  extraReducers: (builder) => {
    builder.addCase(
      createMasterDataBranchAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataBranchAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataBranchAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataBranchAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataBranchAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          masterDataListing: result,
          success,
        };
      }
    );

    builder.addCase(
      getMasterDataBranchAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      checkUniqueBranchNameAction.pending,
      (state: MasterDataType) => ({
        ...state,
        branchFetching: true,
      })
    );

    builder.addCase(
      checkUniqueBranchNameAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, is_exist, message, status_code } = payload?.data;

        if (success === 0) {
          return {
            ...state,
            branchSuccess: success,
            branchFetching: false,
            branchError: message,
            branchSatusCode: status_code,
            isBranchName: is_exist,
          };
        }
        return {
          ...state,
          isBranchName: is_exist,
          branchFetching: false,
          branchMessage: message,
          branchSatusCode: status_code,
          branchSuccess: success,
        };
      }
    );

    builder.addCase(
      checkUniqueBranchNameAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        branchFetching: false,
        branchSuccess: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      checkUniquePdfTemplateNameAction.pending,
      (state: MasterDataType) => ({
        ...state,
        branchFetching: true,
      })
    );

    builder.addCase(
      checkUniquePdfTemplateNameAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, is_exist, message, status_code } = payload?.data;

        if (success === 0) {
          return {
            ...state,
            branchSuccess: success,
            branchFetching: false,
            branchError: message,
            branchSatusCode: status_code,
            isBranchName: is_exist,
          };
        }
        return {
          ...state,
          isBranchName: is_exist,
          branchFetching: false,
          branchMessage: message,
          branchSatusCode: status_code,
          branchSuccess: success,
        };
      }
    );

    builder.addCase(
      checkUniquePdfTemplateNameAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        branchFetching: false,
        branchSuccess: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateMasterDataBranchAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataBranchAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataBranchAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      createMasterClientGroupAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterClientGroupAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterClientGroupAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataClientGroupAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataClientGroupAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          clientGroupList: result,
          success,
          clientGroupTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataClientGroupAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      checkUniqueClientGroupNameAction.pending,
      (state: MasterDataType) => ({
        ...state,
        clientGroupUniqueCheckFetching: true,
      })
    );

    builder.addCase(
      checkUniqueClientGroupNameAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, status_code } = payload?.data;

        if (success === 0) {
          return {
            ...state,
            success: success,
            clientGroupUniqueCheckFetching: false,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          clientGroupUniqueCheckFetching: false,
          clientGroupUniqueCheckMessage: message,
          statusCode: status_code,
          success: success,
        };
      }
    );

    builder.addCase(
      checkUniqueClientGroupNameAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        clientGroupUniqueCheckFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateMasterDataClientGroupAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataClientGroupAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataClientGroupAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      createMasterDataActivityCodeAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataActivityCodeAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataActivityCodeAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataActivityCodeAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataActivityCodeAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          masterDataActivivtyCodeListing: result,
          success,
        };
      }
    );

    builder.addCase(
      getMasterDataActivityCodeAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateMasterDataActivityCodeAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataActivityCodeAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataActivityCodeAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllMasterDataBranchAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllMasterDataBranchAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          masterDataListing: result,
          statusCode: status_code,
          masterDataBranchListTotal: total_count,
        };
      }
    );

    builder.addCase(
      getAllMasterDataBranchAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllMasterDataActivityCodeAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllMasterDataActivityCodeAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          masterDataActivivtyCodeListing: result,
          statusCode: status_code,
          masterDataActivityCodeListTotal: total_count,
        };
      }
    );

    builder.addCase(
      getAllMasterDataActivityCodeAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      createMasterDataCurrencyAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataCurrencyAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataCurrencyAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataCurrencyAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataCurrencyAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          masterDataCurrencyListing: result,
          success,
        };
      }
    );

    builder.addCase(
      getMasterDataCurrencyAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateMasterDataCurrencyAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataCurrencyAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataCurrencyAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllMasterDataCurrencyAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllMasterDataCurrencyAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          masterDataCurrencyListing: result,
          statusCode: status_code,
          masterDataCurrencyListTotal: total_count,
        };
      }
    );

    builder.addCase(
      getAllMasterDataCurrencyAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataEmailersAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataEmailersAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          emailerList: result,
          success,
          emailListTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataEmailersAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterEmailersAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterEmailersAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterEmailersAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterDataEmailersAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataEmailersAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataEmailersAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataHolidayCalenderAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataHolidayCalenderAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          holidayCalenderList: result,
          success,
          holidayCalenderTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataHolidayCalenderAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterHolidayCalenderAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterHolidayCalenderAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterHolidayCalenderAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterDataHolidayCalenderAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataHolidayCalenderAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataHolidayCalenderAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteHolidayCalenderAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteHolidayCalenderAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteHolidayCalenderAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(getAllCountryAction.pending, (state: MasterDataType) => ({
      ...state,
      countryFetching: true,
    }));

    builder.addCase(
      getAllCountryAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, count } = payload;

        if (success === 0) {
          return {
            ...state,
            countryFetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          countryFetching: false,
          statusCode: status_code,
          countryList: result,
          success,
          countryListTotalCount: count ? count : 0,
        };
      }
    );

    builder.addCase(
      getAllCountryAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        countryFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getAllStateAction.pending, (state: MasterDataType) => ({
      ...state,
      stateFetching: true,
    }));

    builder.addCase(
      getAllStateAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, count, is_state } =
          payload;

        if (success === 0) {
          return {
            ...state,
            stateFetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          stateFetching: false,
          statusCode: status_code,
          stateList: result,
          success,
          stateListTotalCount: count,
          isState: is_state,
        };
      }
    );

    builder.addCase(
      getAllStateAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        stateFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllStatePermanentAddressAction.pending,
      (state: MasterDataType) => ({
        ...state,
        stateFetchingPermanentAddress: true,
      })
    );

    builder.addCase(
      getAllStatePermanentAddressAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, count, is_state } =
          payload;

        if (success === 0) {
          return {
            ...state,
            stateFetchingPermanentAddress: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          stateFetchingPermanentAddress: false,
          statusCode: status_code,
          stateListPermanentAddress: result,
          success,
          stateListTotalCountPermanentAddress: count,
          isStatePermanentAddress: is_state,
        };
      }
    );

    builder.addCase(
      getAllStatePermanentAddressAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        stateFetchingPermanentAddress: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getAllCityAction.pending, (state: MasterDataType) => ({
      ...state,
      countryFetching: true,
    }));

    builder.addCase(
      getAllCityAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, count, is_city } =
          payload;

        if (success === 0) {
          return {
            ...state,
            countryFetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          countryFetching: false,
          statusCode: status_code,
          cityList: result,
          success,
          cityListTotalCount: count ? count : 0,
          isCity: is_city,
        };
      }
    );

    builder.addCase(
      getAllCityAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        countryFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllCityPermanentAddressAction.pending,
      (state: MasterDataType) => ({
        ...state,
        cityFetchingPermanentAddress: true,
      })
    );

    builder.addCase(
      getAllCityPermanentAddressAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, count, is_city } =
          payload;

        if (success === 0) {
          return {
            ...state,
            cityFetchingPermanentAddress: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          cityFetchingPermanentAddress: false,
          statusCode: status_code,
          cityListPermanentAddress: result,
          success,
          cityListTotalCountPermanentAddress: count ? count : 0,
          isCityPermanentAddress: is_city,
        };
      }
    );

    builder.addCase(
      getAllCityPermanentAddressAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        cityFetchingPermanentAddress: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getCurrencyExchangeAction.pending,
      (state: MasterDataType) => ({
        ...state,
        rateFetching: true,
      })
    );

    builder.addCase(
      getCurrencyExchangeAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            rateFetching: false,
            success,
            statusCode: status_code,
            error: message,
            currencyExchangeDetails: {
              date: "",
              baseCurrency: "",
              symbol: "",
              rate: "",
            },
          };
        }

        return {
          ...state,
          rateFetching: false,
          statusCode: status_code,
          currencyExchangeDetails: {
            date: result?.date,
            baseCurrency: result?.from,
            symbol: "",
            rate: result?.rate
              ? result?.rate?.toString()?.split(".")[1]?.length > 3
                ? result?.rate?.toFixed(3)
                : result?.rate
              : 1,
          },
          success,
        };
      }
    );

    builder.addCase(
      getCurrencyExchangeAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        rateFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getMasterDataClientCategoryAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataClientCategoryAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          clientCategoryList: result,
          // success,
          clientCategoryTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataClientCategoryAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterDataClientCategoryAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataClientCategoryAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataClientCategoryAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterDataClientCategoryAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataClientCategoryAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataClientCategoryAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataUsersDepartmentAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataUsersDepartmentAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          userDepartmentList: result,
          userDepartmentTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataUsersDepartmentAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterDataUsersDepartmentAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataUsersDepartmentAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataUsersDepartmentAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterDataUsersDepartmentAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataUsersDepartmentAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataUsersDepartmentAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteMasterDataUsersDepartmentAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteMasterDataUsersDepartmentAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteMasterDataUsersDepartmentAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterTdsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterTdsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          tdsDataList: result?.data,
          totalCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getMasterTdsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getMasterTdsModuleSingleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterTdsModuleSingleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          tdsSingleData: result,
          totalCount: result?.total_count,
          message,
        };
      }
    );

    builder.addCase(
      getMasterTdsModuleSingleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterTdsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterTdsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterTdsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterTdsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterTdsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success: 0,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterTdsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteMasterTdsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteMasterTdsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteMasterTdsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataSkillsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataSkillsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          skillMasterDataList: result,
          skillsMasterDataTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataSkillsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterDataSkillsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataSkillsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataSkillsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterDataSkillsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataSkillsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataSkillsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteMasterDataSkillsAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteMasterDataSkillsAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteMasterDataSkillsAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataQualificationModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataQualificationModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          qualificationMasterDataList: result,
          qualificationMasterDataTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataQualificationModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterDataQualificationModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataQualificationModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataQualificationModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterDataQualificationModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataQualificationModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataQualificationModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteMasterDataQualificationAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteMasterDataQualificationAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteMasterDataQualificationAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataScopeOfWorkAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataScopeOfWorkAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          scopeOfWorkList: result,
          scopeOfWorkTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataScopeOfWorkAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterDataScopeOfWorkAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataScopeOfWorkAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataScopeOfWorkAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterDataScopeOfWorkAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataScopeOfWorkAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            fetching: false,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataScopeOfWorkAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteMasterDataScopeOfWorkAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteMasterDataScopeOfWorkAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            fetching: false,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteMasterDataScopeOfWorkAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterTcsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterTcsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          tcsDataList: result?.data,
          totalCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getMasterTcsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getMasterTcsModuleSingleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterTcsModuleSingleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          tcsSingleData: result,
          totalCount: result?.total_count,
          message,
        };
      }
    );

    builder.addCase(
      getMasterTcsModuleSingleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterTcsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterTcsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterTcsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterTcsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterTcsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success: 0,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterTcsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteMasterTcsModuleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteMasterTcsModuleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteMasterTcsModuleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(checkUniqueCode.pending, (state: MasterDataType) => ({
      ...state,
      codeFetching: true,
    }));

    builder.addCase(
      checkUniqueCode.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success: success,
            codeFetching: false,

            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          codeFetching: false,
          codeMessage: message,
          statusCode: status_code,
          success: success,
        };
      }
    );

    builder.addCase(
      checkUniqueCode.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        codeFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getMasterPdfTemplateListAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterPdfTemplateListAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          pdfTemplateList: result?.data,
          pdfTemplateCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getMasterPdfTemplateListAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterPdfTemplateAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterPdfTemplateAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterPdfTemplateAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterPdfTemplateAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterPdfTemplateAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success: 0,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterPdfTemplateAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      deleteMasterPdfTemplateAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteMasterPdfTemplateAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            fetching: false,
            message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteMasterPdfTemplateAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getMasterDataJobTitleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getMasterDataJobTitleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          jobTitleList: result,
          jobTitleTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getMasterDataJobTitleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      createMasterDataJobTitleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createMasterDataJobTitleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      createMasterDataJobTitleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateMasterDataJobTitleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMasterDataJobTitleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success: 0,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateMasterDataJobTitleAction.rejected,
      (state: MasterDataType, { error }) => {
        return {
          ...state,
          success: 0,
          error: error?.message ?? null,
          fetching: false,
        };
      }
    );

    builder.addCase(
      deleteMasterDataJobTitleAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteMasterDataJobTitleAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteMasterDataJobTitleAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getTicketSubCategoryListAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      getTicketSubCategoryListAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          subCategoryList: payload?.result?.data ?? [],
          subCategoryTotalCount: payload?.result?.total_count ?? 0,
          error: null,
          success: payload?.success,
        };
      }
    );
    builder.addCase(
      getTicketSubCategoryListAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addTicketSubCategoryAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      addTicketSubCategoryAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          message: message,
          success: success,
        };
      }
    );
    builder.addCase(
      addTicketSubCategoryAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateTicketSubCategoryAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      updateTicketSubCategoryAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          message: message,
          success: success,
        };
      }
    );
    builder.addCase(
      updateTicketSubCategoryAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateTicketSubCategoryStatusAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      updateTicketSubCategoryStatusAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          message: message,
          success: success,
        };
      }
    );
    builder.addCase(
      updateTicketSubCategoryStatusAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    // ---------- CATEGORY ----------
    builder.addCase(
      getTicketCategoryListAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      getTicketCategoryListAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          categoryList: payload?.result?.data ?? [],
          categoryTotalCount: payload?.result?.total_count ?? 0,
          error: null,
          success: payload?.success,
        };
      }
    );
    builder.addCase(
      getTicketCategoryListAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addTicketCategoryAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      addTicketCategoryAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          message: message,
          success: success,
        };
      }
    );
    builder.addCase(
      addTicketCategoryAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateTicketCategoryAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      updateTicketCategoryAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          message: message,
          success: success,
        };
      }
    );
    builder.addCase(
      updateTicketCategoryAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateTicketCategoryStatusAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      updateTicketCategoryStatusAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          message: message,
          success: success,
        };
      }
    );
    builder.addCase(
      updateTicketCategoryStatusAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getTicketCategoryDetailsAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      getTicketCategoryDetailsAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          singleCategoryDetails: payload?.result ?? {},
          success: payload?.success,
        };
      }
    );
    builder.addCase(
      getTicketCategoryDetailsAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(addKraAction.pending, (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      addKraAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            fetching: false,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      addKraAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(listKraAction.pending, (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      listKraAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          kraList: result?.data,
          success,
          kraTotalCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      listKraAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(updateKraAction.pending, (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateKraAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            fetching: false,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateKraAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(updateKraStatusAction.pending, (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateKraStatusAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateKraStatusAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(deleteKraAction.pending, (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      deleteKraAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteKraAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    // kpi module

    builder.addCase(addKpiAction.pending, (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      addKpiAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            fetching: false,
          };
        }
        return {
          ...state,
          fetching: false,
          message: message,
          success: success,
        };
      }
    );
    builder.addCase(
      addKpiAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getKpiListAction.pending, (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getKpiListAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          kpiList: result?.data,
          kpiListTotalCount: result?.total_count,
          success,
        };
      }
    );

    builder.addCase(
      getKpiListAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getSingleKpiDetailsAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleKpiDetailsAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleKpiDetailsData: result,
          kpiDetailsTotalCount: result?.total_count,
          success,
        };
      }
    );

    builder.addCase(
      getSingleKpiDetailsAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateKpiDetailsAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateKpiDetailsAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            fetching: false,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateKpiDetailsAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    // nature of transaction listing

    builder.addCase(
      getNatureOfTransactionListAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getNatureOfTransactionListAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          natureOfTransactionList: result?.data ?? [],
          natureOfTransactionTotalCount: result?.total_count
            ? +result?.total_count
            : 0,
        };
      }
    );

    builder.addCase(
      getNatureOfTransactionListAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    // relationship type listing

    builder.addCase(
      getRelationshipTypeListAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getRelationshipTypeListAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, status_code, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          relationshipTypeList: result?.data ?? [],
          relationshipTypeTotalCount: result?.total_count
            ? result?.total_count
            : 0,
        };
      }
    );

    builder.addCase(
      getRelationshipTypeListAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    // applicable act listing

    builder.addCase(
      getApplicableActListAction.pending,
      (state: MasterDataType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getApplicableActListAction.fulfilled,
      (state: MasterDataType, { payload }) => {
        const { success, message, status_code, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          applicableActList: result?.data ?? [],
          applicableActTotalCount: result?.total_count
            ? result?.total_count
            : 0,
        };
      }
    );

    builder.addCase(
      getApplicableActListAction.rejected,
      (state: MasterDataType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
  },
});
export const {
  resetMasterError,
  resetMasterSuccess,
  resetMasterMessage,
  resetMasterFetching,
  resetMasterDataActivivtyCodeListing,
  resetMasterDataCurrencyListing,
  resetMasterDataLisitng,
  resetMasterDataActivityCodeListTotal,
  resetMasterDataCurrencyListTotal,
  resetMasterDataBranchListTotal,
  resetBranchSuccess: resetBranchSatusCode,
  resetBranchError,
  resetBranchMessage,
  resetIsBranchName,
  resetBranchFetching,
  resetClientGroupList,
  resetClientGroupTotalCount,
  resetEmailerList,
  resetEmailListTotalCount,
  resetClientGroupUniqueCheckMessage,
  resetClientGroupUniqueCheckFetching,
  resetMasterStatusCode,
  resetCountryList,
  resetCountryListTotalCount,
  resetHolidayCalenderList,
  resetHolidayCalenderTotalCount,
  resetStateList,
  resetStateListTotalCount,
  resetStateFetching,
  resetCityList,
  resetCityListTotalCount,
  resetCityFetching,
  resetCurrencyExchangeDetails,
  resetStateListAddressPermanent,
  resetCityListPermanentAddress,
  resetClientCategoryList,
  resetClientCategoryTotalCount,
  resetUserDepartmentList,
  resetUserDepartmentTotalCount,
  resetTdsModuleList,
  resetTotalCount,
  resetTdsSingleData,
  resetScopeOfWorkList,
  resetScopeTotalCount,
  resetSkillsMasterDataTotalCount,
  resetSkillMasterDataList,
  resetQualificationMasterDataList,
  resetQualificationMasterDataTotalCount,
  resetTcsSingleData,
  resetTcsModuleList,
  setPersistApplicationInProgess,
  setPersistOfferAccepted,
  resetCodeFetching,
  resetCodeError,
  resetCodeMessage,
  resetPdfTemplate,
  resetPdfTemplateCount,
  resetJobTitleList,
  resetJobTitleTotalCount,
  resetKraList,
  resetKraTotalCount,
  resetSubCategoryList,
  resetCategoryList,
  resetCategoryDetails,
  resetCountryFetching,
  resetKpiList,
  resetKpiListTotalCount,
  resetSingleKpiDetails,
  resetKpiDetailsTotalCount,
  resetNatureOfTransaction,
  resetRelationshipTypeList,
  resetApplicableActList,
} = masterDataSlice.actions;
